import { render, staticRenderFns } from "./gasClamp.vue?vue&type=template&id=660f1f5e&scoped=true"
import script from "./gasClamp.vue?vue&type=script&lang=js"
export * from "./gasClamp.vue?vue&type=script&lang=js"
import style0 from "./gasClamp.vue?vue&type=style&index=0&id=660f1f5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660f1f5e",
  null
  
)

export default component.exports